// extracted by mini-css-extract-plugin
export default {"cabecera":"ChatComponent_cabecera__q4fmm","cuerpoChat":"ChatComponent_cuerpoChat__QQHWw"};